import { useEffect, useState } from "react";
import { PlayCircle, X } from "lucide-react";
import { api } from "../../lib/api";
import { Panel, EV_STYLE, ago, dur, evText } from "./util";

const Replay = ({ sid, userId, close }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/admin/insights/session/${sid}`, { params: { user_id: userId } }).then((r) => setD(r.data)); }, [sid, userId]);
  return (
    <div className="fixed inset-0 z-50 bg-black/75 backdrop-blur-md grid place-items-center p-4" onClick={close} data-testid="session-replay">
      <div className="panel w-full max-w-3xl max-h-[85vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <p className="label-xs">Session timeline · {sid}</p>
          <button onClick={close} data-testid="session-replay-close"><X className="w-4 h-4" /></button>
        </div>
        {!d ? <p className="p-6 font-mono text-xs text-white/40">loading…</p> : (
          <div className="overflow-y-auto p-5">
            <p className="font-mono text-[11px] text-white/50 mb-4">{new Date(d.summary.start).toLocaleString()} · {dur(d.summary.duration_s)} · {d.summary.clicks} clicks · {d.summary.errors} errors</p>
            <ol className="relative border-l border-white/10 ml-2 space-y-2">
              {d.events.map((e, i) => {
                const [tone, tag] = EV_STYLE[e.event] || ["text-white/50", e.event];
                return (
                  <li key={i} className="pl-5 relative" data-testid={`replay-event-${i}`}>
                    <span className={`absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full border border-black ${tone.replace("text-", "bg-")}`} />
                    <p className="font-mono text-[11px]"><span className="text-white/35">+{dur(e.t)}</span> <span className={tone}>{tag}</span> <span className="text-white/80">{evText(e)}</span></p>
                  </li>
                );
              })}
            </ol>
          </div>
        )}
      </div>
    </div>
  );
};

export const Sessions = ({ items, userId }) => {
  const [open, setOpen] = useState(null);
  return (
    <Panel title={`Sessions · ${items.length}`} testid="insights-sessions">
      {!items.length && <p className="text-sm text-white/45">No sessions in this window.</p>}
      <ul className="divide-y divide-white/5 max-h-[420px] overflow-y-auto">
        {items.map((s, i) => (
          <li key={s.sid} className="py-3 flex gap-4 items-start group" data-testid={`session-row-${i}`}>
            <button onClick={() => setOpen(s.sid)} className="text-brand mt-0.5 transition-transform group-hover:scale-110" data-testid={`session-open-${i}`}><PlayCircle className="w-5 h-5" /></button>
            <div className="flex-1 min-w-0">
              <p className="text-sm"><span className="text-white">{ago(s.start)}</span> <span className="font-mono text-[11px] text-white/45">· {dur(s.duration_s)} · {s.pages} pages · {s.clicks} clicks{s.errors ? <span className="text-red-400"> · {s.errors} errors</span> : ""}{s.rage ? <span className="text-[#FF2BD6]"> · {s.rage} rage</span> : ""}</span></p>
              <p className="font-mono text-[11px] text-white/55 mt-1 truncate">{s.path.join(" → ") || "—"}</p>
              {s.exit_page && <p className="font-mono text-[10px] text-white/35 mt-0.5">exited on {s.exit_page}</p>}
            </div>
          </li>
        ))}
      </ul>
      {open && <Replay sid={open} userId={userId} close={() => setOpen(null)} />}
    </Panel>
  );
};
